<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    status-module="suggestsysalert"
    :is-edit-desc="false"
    :nameProps="{
      edit: false,
      field: 'res_name',
    }" />
</template>

<script>
import {
  getStatusTableColumn,
} from '@/utils/common/tableColumn'
import {
  getRuleNameTableColumn,
  getSuggestTableColumn,
} from '../utils/columns'
import { resSidepageMap } from '../constants'

export default {
  name: 'SuggestsalertDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getRuleNameTableColumn(),
        getSuggestTableColumn(),
        {
          field: 'res_name',
          title: this.$t('bill.text_127'),
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='res_name' title={row.res_name} hideField={true}>
                    {this.group_by === 'res' ? <side-page-trigger permission='suggestsysalerts_get' name='SuggestsAlertSidePage' id={row.res_id} vm={this} onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger> : row.name}
                  </list-body-cell-wrap>
                  <list-body-cell-wrap copy row={row} field='res_id' hideField title={row.res_id}><span style="color: #999;">{row.res_id}</span></list-body-cell-wrap>
                </div>,
              ]
            },
          },
          formatter: ({ row }) => {
            return row.res_name
          },
        },
        getStatusTableColumn({ statusModule: 'suggestsysalert', title: this.$t('meter.suggest_status') }),
        // getTypeTableColumn(),
        // getRuleNameTableColumn(),
        // getSuggestTableColumn(),
        {
          field: 'usage_type',
          title: this.$t('bill.usage_type'),
        },
        {
          field: 'origin_usage',
          title: this.$t('meter.origin_usage'),
        },
        {
          field: 'suggest_usage',
          title: this.$t('meter.suggest_usage'),
        },
        {
          field: 'usage_unit',
          title: this.$t('meter.usage_unit'),
        },
      ],
    }
  },
  methods: {
    handleOpenResDetail (row) {
      const resInfo = resSidepageMap[row.type]
      if (resInfo) {
        this.$emit('init-side-page-tab', resInfo.initSidePageTab)
        this.$emit('side-page-trigger-handle', this, resInfo.sidePageTriggerHandle, {
          id: row.res_id,
          resource: resInfo.resource,
          apiVersion: resInfo.apiVersion || 'v2',
        }, {
          cancel: () => {
            this.$emit('single-refresh', this.data.id)
          },
        })
      }
    },
  },
}
</script>
